import { constructFrom as a } from "./constructFrom.js";
import { startOfISOWeek as f } from "./startOfISOWeek.js";
import { toDate as i } from "./toDate.js";
function O(t) {
  const r = i(t), e = r.getFullYear(), o = a(t, 0);
  o.setFullYear(e + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const u = f(o), s = a(t, 0);
  s.setFullYear(e, 0, 4), s.setHours(0, 0, 0, 0);
  const n = f(s);
  return r.getTime() >= u.getTime() ? e + 1 : r.getTime() >= n.getTime() ? e : e - 1;
}
export {
  O as default,
  O as getISOWeekYear
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getISOWeekYear.js
// module id = 845
// module chunks = 41